import { useOpenMarketplaceIncentiveTermsModal } from "@faire/retailer-visitor-shared/components/App/AppModals/utils";
import { useFaireDirectMarketplaceIncentive } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectMarketplaceIncentive/useFaireDirectMarketplaceIncentive";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { trackFaireDirectMarketplaceIncentiveBannerViewDetailsClick } from "@faire/web-api--source/events/faireDirect/click/marketplaceIncentiveBannerViewDetails";
import { useCallback } from "react";
export var useFaireDirectMarketplaceIncentiveBannerViewDetailsHandleClick = function() {
    var openMarketplaceIncentiveTermsModal = useOpenMarketplaceIncentiveTermsModal().openMarketplaceIncentiveTermsModal;
    var retailerToken = useRetailerStore([
        "retailerToken"
    ]).retailerToken;
    var isFaireDirectEvergreenIncentive = useFaireDirectMarketplaceIncentive().isFaireDirectEvergreenIncentive;
    var incentiveType = isFaireDirectEvergreenIncentive ? "evergreen" : "marketplace";
    return useCallback(function() {
        trackFaireDirectMarketplaceIncentiveBannerViewDetailsClick(retailerToken !== null && retailerToken !== void 0 ? retailerToken : "", incentiveType);
        openMarketplaceIncentiveTermsModal();
    }, [
        incentiveType,
        openMarketplaceIncentiveTermsModal,
        retailerToken
    ]);
};
